<template lang="pug">
.password-reset(:data-show="isShow" :data-is-forgot-password="props.isForgotPassword")
  v-label.password-reset--heading(v-if="(props.isForgotPassword || (!props.isForgotPassword && resetPasswordSuccess)) && !resetPasswordLinkExpired") C’est parti ! 🙌
  v-label.password-reset--heading(v-if="resetPasswordLinkExpired") Désolé ! 🫢
  v-label.password-reset--heading(v-if="!props.isForgotPassword && !resetPasswordLinkExpired && !resetPasswordSuccess") un instant ! 🧐
  .form-container
    .info(v-if="resetPasswordLinkExpired") Ce lien est expiré.
    .info(v-if="props.isForgotPassword && !resetPasswordLinkExpired && !resetPasswordSuccess") Merci de renseigner les champs suivants.
    .info(v-if="(props.isForgotPassword || (!props.isForgotPassword && resetPasswordSuccess)) && !resetPasswordLinkExpired && resetPasswordSuccess") Félicitations !
      br
      | Votre nouveau mot de passe a bien été pris en compte.
    .info(v-if="!props.isForgotPassword && !resetPasswordLinkExpired && !resetPasswordSuccess") Votre mot de passe est arrivé à expiration. Il vous faut en définir un nouveau.
    v-form.reset-password-form(v-if="!resetPasswordSuccess && !resetPasswordLinkExpired" ref="resetPasswordForm")
      //- .input-container(v-if="!props.isForgotPassword" data-type="password")
      //-   .input-field
      //-     v-text-field(
      //-       elevation="0"
      //-       v-model="oldPassword"
      //-       :rules="[isRequired]"
      //-       variant="outlined"
      //-       name='password'
      //-       density="compact"
      //-       :type="showPassword ? 'text' : 'password'"
      //-       label="Ancien mot de passe"
      //-       single-line
      //-       @click:append="showPassword = !showPassword"
      //-     )
      //-     .input-field__password-icon(@click="showPassword = !showPassword")
      //-       v-icon(v-if="showPassword") mdi-eye-outline
      //-       v-icon(v-else) mdi-eye-off-outline
      //-     .input-field__icon
      //-       v-icon epoca:loginLock
      .input-container(data-type="password")
        .input-field
          v-text-field(
              elevation="0"
              v-model="password"
              :rules="[isRequired]"
              variant="outlined"
              name='newpassword'
              density="compact"
              :type="showPassword ? 'text' : 'password'"
              label="Nouveau mot de passe"
              single-line
              @update:modelValue="onChange"
              @click:append="showPassword = !showPassword"
            )
          .input-field__password-icon(@click="showPassword = !showPassword")
            v-icon(v-if="showPassword") mdi-eye-outline
            v-icon(v-else) mdi-eye-off-outline
          .input-field__icon
            v-icon epoca:loginLock
        .password-hint(v-if="showHint")
          v-label.hint-title Votre mot de passe doit contenir au moins :
          .hint-item(v-for="(item, index) in validationChecks" :data-valid="item.isValid")
            v-icon(v-if="item.isValid") mdi-check
            v-icon(v-else) mdi-close
            v-label {{item.title}}
      .input-container
        .input-field
          v-text-field(
                elevation="0"
                v-model="reTypePassword"
                :rules="[sameAsPassword]"
                variant="outlined"
                name='newpassword'
                density="compact"
                :type="showPassword ? 'text' : 'password'"
                label="Mot de passe"
                single-line
                @click:append="showPassword = !showPassword"
              )
          .input-field__password-icon(@click="showPassword = !showPassword")
            v-icon(v-if="showPassword") mdi-eye-outline
            v-icon(v-else) mdi-eye-off-outline
          .input-field__icon
            v-icon epoca:loginLock
    v-btn.save-btn(v-if="!resetPasswordLinkExpired && !resetPasswordSuccess" :disabled="savePasswordInprogress" @click="savePassword") 
      v-icon(right) epoca:loginKey
      v-label.save-btn--button__label VALIDER
      v-progress-circular(v-if="savePasswordInprogress" indeterminate size="16" :width="2")
    v-btn.save-btn(variant="text" v-if="!resetPasswordLinkExpired && resetPasswordSuccess" @click="logout") 
      v-icon epoca:loginKey
      v-label.save-btn--button__label SE CONNECTER
    v-btn.save-btn(v-if="resetPasswordLinkExpired" @click="logout") 
      v-icon epoca:sendMessage
      v-label.save-btn--button__label RENVOYER LE LIEN PAR EMAIL
      
//- .go-back-btn(v-if="!resetPasswordSuccess && !props.isForgotPassword")
//-   v-btn.elevation-0.btn(color="primary" @click="closeTokenExpire()").checkmark
//-     v-icon mdi-arrow-left
//-     v-label Revenir à l'écran précédent
</template>

<script setup lang="ts">
import { getCurrentUser } from 'vuefire'
const { changePassword, signOut } = useAuth()
const { $api: api, $toast: toast } = useNuxtApp()
const route = useRoute()
const userStore = useUserStore()
const navigationStore = useNavigationStore()
const showPassword = ref<Boolean>(false)
const password = ref<string>('')
const oldPassword = ref<string>('')
const reTypePassword = ref<string>('')
const resetPasswordForm: any = ref(null)
const showHint = ref<Boolean>(false)
const resetPasswordSuccess = ref<Boolean>(false)
const resetPasswordLinkExpired = ref<Boolean>(false)
const savePasswordInprogress = ref<Boolean>(false)

const isRequired = (v: string) => v?.length >= 8 || 'Au moins 8 caractères'

const atleastOneDigit = (v: string) => /\d/.test(v) || 'Au moins un chiffre'

const atleastOneSpecialCharacter = (v: string) =>
  /[!@#$%^&*(),.?":{}|<>]/.test(v) || 'Le mot de passe doit contenir au moins un caractère spécial'

const validationChecks = ref([
  {
    title: 'au moins 8 caractères',
    isValid: false,
    check: isRequired,
  },
  {
    title: 'au moins un chiffre',
    isValid: false,
    check: atleastOneDigit,
  },
  {
    title: 'le mot de passe doit contenir au moins un caractère spécial',
    isValid: false,
    check: atleastOneSpecialCharacter,
  },
])
const props = defineProps({
  isShow: {
    type: Boolean,
    default: () => false,
  },
  isForgotPassword: {
    type: Boolean,
    default: () => false,
  },
})

const sameAsPassword = (v: string) => password.value === reTypePassword.value || `Le mot de passe n'est pas le même`

const onChange = (v: any) => {
  showHint.value = true
  validationChecks.value.forEach((e) => {
    e.isValid = typeof e.check(v) === 'boolean' ? (e.check(v) as boolean) : false
  })
}

const savePassword = async () => {
  savePasswordInprogress.value = true
  if (props.isForgotPassword) {
    try {
      const result = await api.auth.resetPassword({ password: password.value, token: route.query?.token })
      resetPasswordSuccess.value = true
      savePasswordInprogress.value = false
    } catch (error) {
      resetPasswordLinkExpired.value = true
      savePasswordInprogress.value = false
      toast.error(`La demande de réinitialisation du mot de passe n'est pas valide ou a expiré.`, {
        timeout: 5000,
      })
    }
    return
  }

  const data = await resetPasswordForm.value?.validate()
  if (data.valid && userStore?.uid && userStore?.token) {
    resetPasswordSuccess.value = true
    try {
      const user = await getCurrentUser()
      await api.users.extendPasswordExpiration(user?.uid, {
        action: 'extendExpiration',
        mode: 'emailAndPassword',
        value: user?.email,
      })
      await api.auth.deleteSession()
      resetPasswordSuccess.value = true
    } catch (error) {
      toast.error(`Je n'ai pas la permission d'étendre le mot de passe.`, {
        timeout: 5000,
      })
    }
  }
}

async function logout() {
  try {
    // await api.auth.logoutPractitioner(userStore.uid as string, deviceID() as string)
    navigationStore.$reset()
    userStore.$reset()
    await signOut()
  } catch (error) {
    console.error(error)
  }

  window.location.replace('/')
}

const closeTokenExpire = async () => {
  if (userStore.tokenExpire) {
    await api.auth.deleteSession()
    await signOut()
    window.location.replace('/')
  } else if (props.isForgotPassword) {
    window.location.replace('/')
    return
  }
  const tokenExpire = new CustomEvent('on_token_expire', {
    detail: {
      open: false,
    },
  })
  document.dispatchEvent(tokenExpire)
}
</script>

<style lang="stylus" scoped>
.password-reset
  font-family 'Roboto'
  display flex
  flex-direction column
  justify-content space-between
  align-items flex-start
  &--heading
    color: var(--Text-8, #1F1F1F)
    title-t3-uppercase()
    opacity 1
  &[data-show="true"]
    transform translateX(0) !important
    overflow visible
  .form-container
    overflow auto
    width 100%
    margin-top 80px
    display flex
    flex-direction column
    .info
      color: var(--Text-6, #3B3B3B)
      body-b4-medium()
    .logo
      width 315px
      height 177px
    .reset-password-form
      width 100%
      align-items center
      display flex
      flex-direction column
      .input-container
        width 100%
        margin-top 23px
        .input-field
          position relative
          &__password-icon
            position absolute
            cursor pointer
            top: 10px;
            right: 42px;
            height: 20px;
            display: flex
            align-items: center;
            justify-content: center;
            .v-icon
              height 20px
              width 20px
              font-size: 20px;
              color var(--Text-4, #747474)
          &__icon
            position absolute
            top: 10px;
            right: 8px;
            height: 20px;
            padding-left: 5px;
            border-left 1px solid var(--Text-3, #A4A4A4)
            display: flex
            align-items: center
            justify-content: center
            .v-icon
              height 20px
              width 20px
              font-size: 20px;
              color var(--Text-4, #747474)
                &[data-type='password']
                  :deep().v-field
                    input
                      padding-right 80px
          :deep().v-input
            &__details
              color var(--Primary-Warning, #FF4D6A)
              padding-left 0
              body-b3-regular()
          :deep().v-field
            border-radius 4px
            background var(--Textfield-Input-BG-Dark, rgba(0, 0, 0, 0.08)) !important
            border-left 4px solid transparent
            &__outline
              display none
            &--error
              border-left 4px solid var(--Primary-Warning, #FF4D6A)
            .v-label.v-field-label
              margin-left 8px
              padding-right 25px
              color var(--Text-4, #747474)
              body-b3-medium()
            input
              padding-left 8px
              padding-right 50px
              color var(--Text-8, #1F1F1F)
              body-b3-medium()
              &[type="password"]
                font-family caption
                font-size: 20px;
              :deep().v-input
                &__details
                  display none
        .password-hint
          display flex
          flex-direction column
          align-items flex-start
          gap 2px
          padding-top 8px
          .hint-title
            opacity 1
            font-weight 500
            font-size var(--fs-9)
          .hint-item
            display flex
            align-items center
            justify-content center
            gap 5px
            color var(--cruel-ruby, #DD3148)
            &[data-valid="true"]
              color #1FC065
            .v-icon
              font-size var(--fs-10)
            .v-label
              opacity 1
              font-weight 500
              font-size var(--fs-9)
    .save-btn
      display: flex;
      height: 40px;
      padding: 0px 24px;
      justify-content: center;
      align-items: center;
      align-self: stretch;
      width: 100%;
      border-radius: 4px;
      margin-top: 32px;
      background: var(--Primary-Brand-Lime, #97FF8C);
      &:hover
        background: linear-gradient(to bottom, #97FF8C 0%, #6EE7B7 100%);
      &--button__label
        color: var(--Text-8, #1F1F1F);
        body-b3-semibold();
        opacity 1;
      &__label
        color: var(--Text-8, #1F1F1F)
        body-b3-semibold()
        opacity 1
      :deep().v-btn
        &__content
          gap: 8px;
    .heading
      display flex
      align-items center
      justify-content center
      flex-direction column
      padding-top 25px
      padding-bottom 25px
      .sub-heading
        width 85%
        padding-top 20px
        .v-label
          opacity 1
          font-size var(--fs-13)
          font-weight 400
          white-space pre-wrap
          text-align center
      .v-icon
        font-size var(--fs-32)
        padding-bottom 15px
        color var(--maximum-red, #D81818)
        &.success
          color #1FC065
      .v-label
        opacity 1
        font-size var(--fs-22)
        font-weight 700
  .disconnect-btn
    width 80%
    height 40px
    margin-top 35px
    text-transform none
    :deep().v-btn
      &__content
        display flex
        gap 5px
    .v-icon
      font-size var(--fs-18)
    .v-label
      font-size var(--fs-13)
      opacity 1
  .go-back-btn
    width 100%
    .btn
      height 30px
      background-color #fff !important
      color #070E12 !important;
      cursor pointer
      gap 5px
      align-items center
      .v-icon
        font-size var(--fs-24)
      .v-label
        cursor pointer
        opacity 1
        font-weight 400
        font-size var(--fs-14)
        text-transform none
</style>
